module.exports = __webpack_public_path__ + "static/media/defaultImage.0424a1b4.png";